module.exports = __webpack_public_path__ + "static/media/twitter.97c4124b.svg";